import * as React from "react";
import UploadData from "./components/UploadData";
import UnAuthenticatedError from "@/components/UnAuthenticatedError";
import Frame from "@/popups/uploadData/components/Frame";
import { Route, MemoryRouter as Router, Routes } from "react-router-dom";
import "@/styles/globals.css";

const App: React.FC = () => {
  window.history.replaceState(null, "", window.location.pathname);
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  
  return (
    <>
      {isAuthenticated ? (
        <div style={{ minHeight: "100vh" }}>
          <Router>
            <Routes>
              <Route path="/" element={
                <Frame>
                  <div>AlphaScript</div>
                </Frame>
              } />
              <Route path="/capitalization-template" element={
                <Frame>
                  <UploadData />
                </Frame>
              } />
              </Routes>
            </Router>
        </div>
      ) : (
        <UnAuthenticatedError />
      )}
    </>
  );
};

export default App;

